import { Alert as AntdAlert } from 'antd'
import styled from '@emotion/styled'

export const Alert = styled(AntdAlert)`
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border: none;
  border-radius: 4px;
`

export const Line = styled('div')`
  background: #e5e5e5;
  margin: 5px 0px;
  height: 1px;
`
